<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-row justify="center">
            <v-btn class="mt-6 button" style="background: color-mix(in srgb, var(--v-brand-base) 65%, white) !important;" @click="track_flag=false;type_flag=true;config_flag=false">Serial
                Field Type Master</v-btn>
            <v-btn class="mt-6 button" style="background: color-mix(in srgb, var(--v-brand-base) 65%, white) !important;" @click="track_flag=false;type_flag=false;config_flag=true">Serial
                Field Config</v-btn>
            <v-btn class="mt-6 button" style="background: color-mix(in srgb, var(--v-brand-base) 65%, white) !important;" @click="track_flag=true;type_flag=false;config_flag=false">Serial
                Field Tracking</v-btn>
        </v-row>
        <serial-field-tracking v-if="track_flag"></serial-field-tracking>
        <serial-field-type v-if="type_flag"></serial-field-type>
        <serial-field-config v-if="config_flag"></serial-field-config>
    </div>
</template>
<script>
    import axios from "axios";
    import SerialFieldTracking from "./SerialFieldTracking"
    import SerialFieldTypeMaster from "./SerialFieldTypeMaster"
import SerialFieldConfig from "../SerialFieldConfig"
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    export default {
        components:{
             "serial-field-tracking": SerialFieldTracking ,
             "serial-field-type":SerialFieldTypeMaster ,
            "serial-field-config": SerialFieldConfig,
            Breadcrumbs
        },
        data: () => ({
         type_flag : true,
         track_flag : false,
            config_flag: false,
        //    extraBreadcrumbItems: [
                

        //     ],
        //     breadcrumbClass: "breadcrumb-style1",
        }),
        mounted() {
            
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },

        
        },
    };
</script>
<style scoped>
  
</style>
